<template>
  <div style="padding: 10px 20px;">
    <vxe-toolbar
      id="toolbarId_ol1"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter">
          查询
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      height="600"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      :loading="loading"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <!--      <vxe-table-column field="reserveTime" title="预约时间" min-width="160" sortable>-->
      <!--      </vxe-table-column>-->
      <vxe-table-column
        field="gmtCreated"
        title="下单时间"
        min-width="160"
        sortable
      />
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="签收时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.fromDate"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="mainOrderNumber"
        title="主单号11"
        min-width="160"
        sortable
      />
      <vxe-table-column>
        <vxe-table-column
          field="cargoName"
          title="货物名称"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.cargoName"
            placeholder="输入货物名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentName"
          title="发货方姓名"
          min-width="160"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentName"
            placeholder="输入发货方姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentPhone"
          title="发货方电话"
          min-width="160"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentPhone"
            placeholder="输入发货方电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="loadingAddress"
        title="发货方地址"
        min-width="160"
        sortable
      />
      <vxe-table-column
        field="transportType"
        title="运输方式"
        min-width="160"
        :formatter="formattertrTansportType"
        sortable
      />
      <!--      <vxe-table-column>-->
      <!--        <vxe-table-column field="licenseNumber" title="接货车牌号" min-width="160"/>-->
      <!--      </vxe-table-column>-->
      <vxe-table-column field="upstreamCost" title="上游运费" min-width="160" />
      <vxe-table-column
        field="upstreamCostActual"
        title="实际上游运费"
        min-width="160"
      />
      <vxe-table-column
        field="driverFreight"
        title="实际承运人运费"
        min-width="160"
      />
      <vxe-table-column
        field="collectionDelivery"
        title="代收款"
        min-width="160"
      />
      <vxe-table-column title="操作" fixed="right" min-width="80">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="查看订单"
            placement="top"
          >
            <vxe-button type="text" @click="checkOrderDetails(scope.row)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <!-- 查看订单详情 -->
    <vxe-modal
      v-model="isorderManage"
      title="查看订单"
      width="65%"
      height="auto"
      :lock-scroll="false"
    >
      <orderManage
        ref="addRef"
        :col="currentCol"
        class="orderManage"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
  </div>
</template>
<script>
import { ajax } from "@/api/ctms";

import orderManage from "@/components/waybillManagement";
export default {
  name: "Parent",
  components: {
    orderManage
    //compEdit
  },
  data() {
    return {
      loading: false,
      modelLookFlag: false,
      isorderManage: false,
      currentCol: "",
      tableData: [],
      restaurants: [],
      liabilityDueDateRange: "",
      compulsoryDueDateRange: "",
      commercialDueDateRange: "",
      gmtCreatedRange: "",
      form: {
        username: "",
        phone: ""
      },
      modelAddFlag: false,
      modelEditFlag: false,
      listQuery: {
        code: "",
        createdBy: "",
        cargoName: "",
        shipmentName: "",
        shipmentPhone: "",
        receiveVehicleNumber: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      Pagingconf: []
    };
  },
  created() {
    // this.findList();
  },
  methods: {
    findList() {
      //this.listQuery.createdBy=code;
      ajax("/ntocc-ctms-api/ctmsOrder", "get", this.listQuery)
        .then(data => {
          this.listQuery.total = data.data.total;
          data.data.total
            ? (this.Pagingconf = [20, 30, 50, 100, data.data.total])
            : (this.Pagingconf = [20, 30, 50, 100]);
          this.tableData = data.data.records;
          this.loading = false;
        })
        .catch(error => {});
    },
    // 展示弹框
    showModel(code, costRemark, prefix) {
      if (code) {
        this.$refs[`${prefix}Ref`].getInfo(code, costRemark);
      }
      this[`model${prefix}Flag`] = true;
    },
    // 隐藏弹框
    hideModel() {
      this.modelAddFlag = false;
      this.modelEditFlag = false;
      this.findList();
    },
    // 添加备注按钮
    checkOrderDetails(data) {
      this.$refs.addRef.listQuery.mainOrderCode = data.code;
      this.$refs.addRef.WaybillManagementList();
      this.isorderManage = true;
      this.currentCol = data;
    },
    // 列表展示status字段翻译
    formattertrTansportType({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "整车";
        case 1:
          return "零担";
        default:
          return "其他状态";
      }
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.isorderManage = false;
          break;
        case "edit":
          this.modelEditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
      this.findList();
    },
    // 分页
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    }
    // 设置底部合计
    // footerMethod({ columns, data }) {
    //     return [
    //         columns.map((column, columnIndex) => {
    //             if (columnIndex === 0) {
    //                 return "合计";
    //             }
    //             if (["pageviews", "forecast"].includes(column.property)) {
    //                 return this.$XEUtils.sum(data, column.property);
    //             }
    //             return null;
    //         })
    //     ];
    // }
  }
};
</script>
<style scoped>
::v-deep.el-dialog__body {
  padding: 5px;
}
::v-deep .el-dialog__header {
  padding: 10px;
}
/*.orderManage｛ {
    z-index:9!important;
  }*/
</style>
